class RebatesReimbursementsController {
    constructor($scope, $http, $window, $timeout) {
        'ngInject';
        this.$scope = $scope;
        this.$http = $http;
        this.$window = $window;
        this.$timeout = $timeout;

        this.data = {};

        this.spinner = false;
        this.httpError = false;
    }

    $onInit() {
        this.spinner = true;
        this.$timeout(() => {
            this.$http({
                url: '/api/chapterleader/getchapterrebates',
                method: 'GET'
            }).then((response) => {
                this.spinner = false;
                this.data = response.data;
                console.log(this.data);
            }, (response) => {
                this.spinner = false;
                this.httpError = true;
            });
        }, 1000);
    }
}

export default RebatesReimbursementsController;



// WEBPACK FOOTER //
// ./src/app/angular/rebates-reimbursements/rebates-reimbursements.controller.js